import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { templatesApi } from '@/api/templates.api';
import { extractErrorMessage } from '@/lib/errors';
import type { TemplateType } from '@/types/api.types';

export function useTemplatesList(params?: { type?: TemplateType; isActive?: boolean }) {
  return useQuery({
    queryKey: ['templates', params],
    queryFn: () => templatesApi.list({ pageSize: 100, ...params }),
    select: (res) => res.data,
  });
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: templatesApi.create,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['templates'] });
      toast.success('Template criado com sucesso');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useUpdateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Parameters<typeof templatesApi.update>[1] }) =>
      templatesApi.update(id, data),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['templates'] });
      toast.success('Template atualizado');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useDeleteTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: templatesApi.delete,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['templates'] });
      toast.success('Template removido');
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}

export function useSyncZenviaTemplates() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: templatesApi.syncFromZenvia,
    onSuccess: (res) => {
      void qc.invalidateQueries({ queryKey: ['templates'] });
      const { imported, updated, removed } = res.data.data;
      const parts = [`${imported} importado(s)`, `${updated} atualizado(s)`];
      if (removed > 0) parts.push(`${removed} removido(s)`);
      toast.success(parts.join(', '));
    },
    onError: (err) => toast.error(extractErrorMessage(err)),
  });
}
